import ReactOnRails from "react-on-rails";
import * as Sentry from "@sentry/react";

const isRenderFunction = (component) =>
  !component.prototype?.isReactComponent &&
  (Boolean(component.renderFunction) || component.length >= 2);

const reportingRenderCrashes = (component) =>
  isRenderFunction(component) ? component : Sentry.withErrorBoundary(component, {});

export default function registerComponents(components) {
  ReactOnRails.register(
    Object.fromEntries(
      Object.entries(components).map(([name, component]) => [name, reportingRenderCrashes(component)])
    )
  );
}
